import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class Interceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    public toastr: ToastrService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // const customReq = request.clone({});

    return <any>next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // this.toastr.error(error.message);
        if (error.status === 401) {
          this._authService.Logout();
          return 'Token expired!';
        }
        // else if (error.status === 400) {
        //   this._authService.Logout()
        //   return throwError(error);
        // }
        else {
          console.log(error);
          return throwError(error);
        }
      })
    );
  }
}
